import { computed } from "vue";
import { i18n } from "./../../i18n";
const { t } = i18n.global;

const menuItems = computed(() => [
    {
        slug: "archived-files",
        path: "/archived-files",
        name: "Archived-Files",
        label: t("archivehub.pages.menuItems.archivedFiles.linkLabel"),
    },
]);

export { menuItems };
